import { ColorPickerComponent } from './color-picker.component';
import { Component } from '@angular/core';
import { Color } from '../../../models/color';
import { CommunicationService } from '../../../services/communication.service';

import { ColorPipe } from '../../../pipes/color.pipe';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-draw-mode-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    standalone: true,
    imports: [
        ColorPipe,
        NgStyle
    ]
})
export class DrawModeColorPickerComponent extends ColorPickerComponent {

    constructor(private communicationService: CommunicationService) {
        super();
    }

    setColor(color: Color): void {
        this.colorable.color = color;
        this.communicationService.changeDrawModeColor(this.colorable);
    }
}
